import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const AccountLazy = lazyLoader(
  () => import('./Account' /* webpackChunkName: "account" */),
);

const Account = () => {
  return (
    <Suspense fallback={null}>
      <AccountLazy />
    </Suspense>
  );
};

export default Account;
